/**
 * Template Edit panel
 *
 * Author: Fernando
 */
import React from 'react';
import StoredLayout from 'layouts/StoredLayout';
import { connect } from 'react-redux';

import { Button, Container } from 'reactstrap';
import ScoresheetViewPanel from 'pages/staff/certification/assessment/components/ScoresheetViewPanel';
import history from '../../../../../history';

class ServiceAssessmentPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onBackButtonClicked = this.onBackButtonClicked.bind(this);
    }
    onBackButtonClicked() {
        const { certid } = this.props.match.params;
        history.push(`/member/certification/service/renew/${certid}`);
    }
    render() {
        return (
            <Container style={{ marginTop: '30px' }}>
                <div>
                    <Button className="primary-btn-style mr-2" onClick={this.onBackButtonClicked}>
                        <i className="mr-1 material-icons align-text-bottom ">keyboard_arrow_left</i>
                        Back
                    </Button>
                </div>
                <div>
                    {this.props.match.params.scoresheetid && this.props.match.params.applicationid && (
                        <ScoresheetViewPanel
                            adjustPrintButton
                            type={this.props.type}
                            templateId={this.props.match.params.templateid}
                            scoresheetId={this.props.match.params.scoresheetid}
                            applicationId={this.props.match.params.applicationid}
                            isMember={true}
                            showInstruction={true}
                        />
                    )}
                </div>
            </Container>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => ({});

export default StoredLayout(connect(mapStateToProps, mapDispatchToProps)(ServiceAssessmentPage));
